/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**************************************!*\
  !*** ./src/js/complexion-reviews.js ***!
  \**************************************/
/*
 * Reviews wall for the Complexion landing page.
 *
 * Cards are curated review blocks rendered by Liquid, so there is no review platform behind
 * this section and nothing is fetched at runtime.
 *
 * Desktop renders every block and holds the ones past the initial count behind
 * .complexion-reviews__card--desktop-hidden, which the load more button releases a step at a
 * time. Mobile caps its own count with .complexion-reviews__card--mobile-hidden and links out
 * to the reviews page instead of paging.
 */
(function () {
  var DESKTOP_HIDDEN_CLASS = 'complexion-reviews__card--desktop-hidden';
  var initialised = new WeakSet();

  function getHiddenCards(section) {
    return Array.from(section.querySelectorAll('.' + DESKTOP_HIDDEN_CLASS));
  }

  function updateControls(section) {
    var loadMoreButton = section.querySelector('[data-reviews-load-more]');
    var viewAllLink = section.querySelector('[data-reviews-view-all]');
    var hasMore = getHiddenCards(section).length > 0;

    if (loadMoreButton) {
      // Inline display, as .btn's inline-flex beats the hidden attribute.
      loadMoreButton.style.display = hasMore ? '' : 'none';
    } // The desktop CTA becomes the view all link once every review is on the page.


    if (viewAllLink) {
      viewAllLink.classList.toggle('lg:hidden', hasMore);
    }
  }

  function focusCard(card) {
    if (!card) {
      return;
    }

    card.setAttribute('tabindex', '-1');
    card.focus({
      preventScroll: true
    });
  }

  function loadMore(section) {
    var hidden = getHiddenCards(section);

    if (!hidden.length) {
      return;
    }

    var step = parseInt(section.dataset.desktopStep, 10) || 3;
    hidden.slice(0, step).forEach(function (card) {
      card.classList.remove(DESKTOP_HIDDEN_CLASS);
    });
    updateControls(section);
    focusCard(hidden[0]);
  }

  function initSection(section) {
    if (initialised.has(section)) {
      return;
    }

    initialised.add(section);
    var loadMoreButton = section.querySelector('[data-reviews-load-more]');

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        loadMore(section);
      });
    }

    updateControls(section);
  }

  function init(root) {
    var scope = root || document;
    Array.from(scope.querySelectorAll('[data-complexion-reviews]')).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  } // Sections re-render as settings change in the theme editor.


  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
/******/ })()
;